import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Search from "../commoncomponents/Search";
import ShowEntries from "../commoncomponents/ShowEntries";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import DeviceTable from "./deviceTable";
import { encodeQueryData } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import queryString from "query-string";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class Devices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      deviceList: [],
      pageCount: 0,
      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "1",
      entryEnd: "50",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,
    };
    this.pageSize = "50";
    this.pageKey = "1";
    this.searchText = "";
    this.sortDirection = "";
    this.sortString = "";
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    var urlAll = "";
    if (values.customerId) {
      this.customerId = values.customerId;
      let query = encodeQueryData(this.setDeviceQueryObject());
      urlAll = `${apiHost}/api/Device/AllDevice?${query}`;
      this.getDevices(urlAll);
    } else {
      let query = encodeQueryData(this.setDeviceQueryObject());

      urlAll = `${apiHost}/api/Device/AllDevice?${query}&?SortDirection=asc&SortString=customer`;
      this.getDevices(urlAll);
    }
  }

  getDevices = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      let deviceList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        deviceList: deviceList.data,
        pageCount: JSON.parse(deviceList.headers.pagination).totalPages,
      });
      this.handleShowResults(deviceList);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleShowEntries = (inputShowEntries) => {
    this.pageSize = inputShowEntries;
    let query = encodeQueryData(this.setDeviceQueryObject());
    let urlAll = `${apiHost}/api/Device/AllDevice?${query}`;
    this.getDevices(urlAll);
  };

  handlePagination = (page) => {
    this.pageKey = page;
    let query = encodeQueryData(this.setDeviceQueryObject());
    let urlAll = `${apiHost}/api/Device/AllDevice?${query}`;
    this.getDevices(urlAll);
  };

  handleSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessage: false });
    } else {
      this.setState({ filterMessage: true });
    }

    this.searchText = inputSearch;
    let query = encodeQueryData(this.setDeviceQueryObject());
    let urlAll = `${apiHost}/api/Device/AllDevice?${query}`;
    this.getDevices(urlAll);
  };

  setDeviceQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageSize == 1000000 ? 1 : this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = data.SortString = this.customerId ? "name" : this.sortString;;
    return data;
  };

  handleSort = (name, order) => {
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setDeviceQueryObject());
    let urlAll = `${apiHost}/api/Device/AllDevice?${query}`;
    this.getDevices(urlAll);
  };

  handleShowResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(response.headers.pagination).totalItems,
    });
    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(response.headers.pagination).totalItems,
        totalFilter: true,
      });
    }
    this.setState({
      entryStart: parseInt(this.pageSize) == 1000000 ? 1 : (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEnd)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.pageSize);
      this.setState({ entryEnd: value });
    }
    if (
      this.state.entryEnd >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    }
    if (this.state.deviceList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };
  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/create-new-devices?selectedAsset=${values.customerName}&customerId=${values.customerId}`
      );
    } else {
      this.props.history.push(`/create-new-devices`);
    }
  };

  render() {
    const arr = [50, 100, 150, 200, 1000000];
    const values = queryString.parse(this.props.location.search);

    return (
      <div>
        <Layout>
          <Helmet>
            <title>All Devices </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>
                Devices
                {values.customerId && (
                  <small>
                    {`filtered by customerName `}
                    <a
                      onClick={() => localStorage.removeItem("customer")}
                      href="/devices"
                    >
                      <span>
                        <i className=" fa fa-times"></i>
                        {values.customerName}
                      </span>
                    </a>
                  </small>
                )}
              </h2>

              <Button variant="primary" onClick={() => this.handleCreateNew()}>
                Create New
              </Button>

              <div className="inline">
                <ShowEntries
                  showEntriesCallback={this.handleShowEntries}
                  data={arr}
                />
                <Search searchCallback={this.handleSearch} />
              </div>
              <div className="deviceTable">
                <DeviceTable
                  deviceList={this.state.deviceList}
                  sortFunction={this.handleSort}
                />
              </div>
              <div className="paginationDetails">
                <ShowingResults
                  currentEntryStart={this.state.entryStart}
                  currentEntryEnd={this.state.entryEnd}
                  totalEntries={this.state.totalEntry}
                  totalFilterEntries={this.state.totalEntryFilter}
                  filterMessage={this.state.filterMessage}
                />
                <Paginations
                  pageCount={this.state.pageCount}
                  pageRange={5}
                  onPagination={this.handlePagination}
                ></Paginations>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Devices);
